import React, { useMemo, useState } from "react";
import clxs from "./detail-form.module.css";
import CLOSE_ICON from "../../../assets/icons/close-room-details.svg";
import VillaItem from "../VillaItem";
import LandingpageForm from "../../LandingPageForm";
import { LOCATIONS_BANNER_MAP } from "../../Locations/location-banner-template";
import { useQueryParamValue } from "../../../hooks/use-query-param";
import useIsMobile from "../../../hooks/use-is-mobile";

interface DetailFormProps {
  property?: PropertyItem;
  onSubmit?: (out: any) => void;
  className?: string;
}

function DetailForm(props: DetailFormProps) {
  const { property, onSubmit } = props,
  { isMobile } = useIsMobile(),
  destination= useQueryParamValue("string", "destination") || "default",
  [isResetForm, setIsResetForm] = useState<boolean>(false),
  formId = useMemo(
    () => `${FORM_ID}-${property?.property_slug}`,
    [property?.property_slug],
  ),
  showInternational = useMemo(
    () => {
      return LOCATIONS_BANNER_MAP[`${destination}`]?.annotation === "domestic";
    },
    [destination],
  );
   
  return (
    <div className={clxs.container}>
      <div className={clxs.header}>
          <img
            src={CLOSE_ICON}
            alt="close"
            className={clxs.close}
            onClick={() => {
              onSubmit?.(null);
              setIsResetForm(true);
            }}
          />
      </div>
      {isMobile  ? null :
      <div className={clxs.detailFormContainer}>
        {property && (
          <VillaItem 
            property={property}
            className={clxs.detailForm}
            isDetailForm={true}
          />
        )}
      </div>}
      {isMobile  ? null : <div className={clxs.verticalLine}></div>}
      <div className="">
          <LandingpageForm
            className={clxs.sendRequest}
            title={isMobile ? "Send us your request":"Experience luxury like never before with Lohono Stays!" }
            subtitle="Send us your request below and our team will get back to you soon"
            formId={formId}
            showInternational={showInternational}
            isResetForm={isResetForm}
          />
      </div>
    </div>
  );
}

export default DetailForm;

const FORM_ID = "detail_page_form";


